export function clonify(d) {
    return JSON.parse(JSON.stringify(d));
}

export function isNullOrUndefined(value: any){
  return value === undefined || value === null;
}
